import { API_LOGS } from 'utils/constants'
import Api from './axiosInstance'

type LogCommon = {
  limit: number
  page: number
}

//  To get all ERP logs from server
export const fetchErpLogs = ({ limit, page }: LogCommon) => {
  return Api.get({ url: `${API_LOGS.ERP_LOGS}?limit=${limit}&page=${page}` })
}

// To get all ERP logs from server
export const downloadErpLogs = () => {
  return Api.get({ url: API_LOGS.ERP_LOGS_DOWNLOAD })
}

//  To get all POS logs from server
export const fetchPosLogs = ({ limit, page }: LogCommon) => {
  return Api.get({ url: `${API_LOGS.POS_LOGS}?limit=${limit}&page=${page}` })
}

// To get all ERP logs from server
export const downloadPosLogs = () => {
  return Api.get({ url: API_LOGS.POS_LOGS_DOWNLOAD })
}

// To get all POS logs from server
export const fetchFtpLogs = ({ limit, page }: LogCommon) => {
  return Api.get({ url: `${API_LOGS.FTP_LOGS}?limit=${limit}&page=${page}` })
}

// To get all ERP logs from server
export const downloadFtpLogs = () => {
  return Api.get({ url: API_LOGS.FTP_LOGS_DOWNLOAD })
}

// To get all POS logs from server
export const fetchImportLogs = ({ limit, page }: LogCommon) => {
  return Api.get({
    url: `${API_LOGS.IMPORTS_LOGS}?limit=${limit}&page=${page}`,
  })
}

// To get all POS logs from server
export const fetchOrdersLogs = ({ limit, page }: LogCommon) => {
  return Api.get({
    url: `${API_LOGS.ORDERS_LOGS}?limit=${limit}&page=${page}`,
  })
}

// To get all POS logs from server
export const fetchReconciliationLogs = ({ limit, page }: LogCommon) => {
  return Api.get({
    url: `${API_LOGS.RECONCILIATION_LOGS}?limit=${limit}&page=${page}`,
  })
}

// To get all Import logs from server
export const downloadImportLogs = () => {
  return Api.get({ url: API_LOGS.IMPORTS_LOGS_DOWNLOAD })
}

// To get all Orders logs from server
export const downloadOrdersLogs = () => {
  return Api.get({ url: API_LOGS.ORDERS_LOGS_DOWNLOAD })
}

// To get all Orders logs from server
export const downloadReconciliationLogs = () => {
  return Api.get({ url: API_LOGS.RECONCILIATION_LOGS_DOWNLOAD })
}

// To get all Export logs from server
export const fetchExportLogs = ({ limit, page }: LogCommon) => {
  return Api.get({
    url: `${API_LOGS.EXPORT_LOGS}?limit=${limit}&page=${page}`,
  })
}

// To get all Export logs from server
export const downloadExportLogs = () => {
  return Api.get({ url: API_LOGS.EXPORT_LOGS_DOWNLOAD })
}

// To get all Aggregator API Logs from server
export const fetchAggregatorApiLogs = ({ limit, page }: LogCommon) => {
  return Api.get({
    url: `${API_LOGS.AGGREGATOR_LOGS}?limit=${limit}&page=${page}`,
  })
}

// To get all Aggregator API Logs from server
export const downloadAggregatorApiLog = () => {
  return Api.get({ url: API_LOGS.AGGREGATOR_LOGS_DOWNLOAD })
}

export const downloadSingleLogFile = (value: string) => {
  return Api.get({ url: value })
}
